
'use strict';

(function () {
  if (!customElements.get('slideshow-banner')) {
    const BREAKPOINTS = {
      sm: 750,
      lg: 990,
    };

    class SlideshowBanner extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.handleViewportChange = this.handleViewportChange.bind(this);
      }

      connectedCallback() {
        this.pagination = this.querySelector('.swiper-pagination');
        if (this.mobileQuery.addEventListener) {
          this.mobileQuery.addEventListener('change', this.handleViewportChange);
        } else {
          this.mobileQuery.addListener(this.handleViewportChange);
        }
        this.scheduleInit();
      }

      disconnectedCallback() {
        if (this.mobileQuery.removeEventListener) {
          this.mobileQuery.removeEventListener('change', this.handleViewportChange);
        } else {
          this.mobileQuery.removeListener(this.handleViewportChange);
        }
        this.destroySwiper();
      }

      scheduleInit() {
        if (this.shouldUseStaticMobile()) {
          this.destroySwiper();
          return;
        }

        const init = () => this.initSwiper();

        if (document.readyState === 'complete') {
          this.runWhenIdle(init);
        } else {
          window.addEventListener('load', () => this.runWhenIdle(init), { once: true });
        }
      }

      runWhenIdle(callback) {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(callback, { timeout: 1500 });
        } else {
          window.setTimeout(callback, 1);
        }
      }

      shouldUseStaticMobile() {
        return this.dataset.mobileStatic === 'true' && this.mobileQuery.matches;
      }

      handleViewportChange() {
        if (this.shouldUseStaticMobile()) {
          this.destroySwiper();
          return;
        }

        this.scheduleInit();
      }

      destroySwiper() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      initSwiper = () => {
        if (this.swiper || this.shouldUseStaticMobile() || typeof Swiper === 'undefined') return;

        const slides = this.querySelectorAll('.swiper-slide');
        const slidesLength = slides.length;
        let { slidesPerView = 1, slidesPerViewSm, slidesPerViewLg, effect, speed, autoplay, loop = 'false', spaceBetween, spaceBetweenPc } = this.dataset;
        if (!slidesPerViewSm) slidesPerViewSm = slidesPerView;
        if (!slidesPerViewLg) slidesPerViewLg = slidesPerView;

        slidesPerView = slidesLength < +slidesPerView ? slidesLength : +slidesPerView;
        slidesPerViewSm = slidesLength < +slidesPerViewSm ? slidesLength : +slidesPerViewSm;
        slidesPerViewLg = slidesLength < +slidesPerViewLg ? slidesLength : +slidesPerViewLg;


				speed = speed * 1000;

        if (autoplay == 'true') {
          autoplay = {
						delay: speed,
						disableOnInteraction: false,
          };
        } else {
					autoplay = false;
				}

        let pagination = false;

				loop = loop == 'false' || slidesLength <= 1 ? false : true;

        if (this.pagination) {
          pagination = {
            el: '.swiper-pagination',
						clickable: true
          };
        }

        const swiperParams = {
					autoplay,
          slidesPerView,
          pagination,
					grabCursor: true,
					effect,
					centeredSlides: true,
					loop: loop,
          observer: false,
          resizeObserver: false,
          spaceBetween,
					// initialSlide: 0,
          breakpoints: {
            [BREAKPOINTS.sm]: {
              slidesPerView: slidesPerViewSm,
              spaceBetween: spaceBetweenPc,
            },
            [BREAKPOINTS.lg]: {
              slidesPerView: slidesPerViewLg,
              spaceBetween: spaceBetweenPc,
            },
          },
        };

        this.swiper = new Swiper(this, swiperParams);
      };
    }

    customElements.define('slideshow-banner', SlideshowBanner);
  }
})();

